// @flow
import client from '../../client'
import format from '../../utils/format'

// API Endpoinds
export const GET_PROVIDER_ENDPOINT = '/data-entry/providers/{0}/'

/**
 * Returns an updated provider
 * @param {Object} data Data
 * @param {string} data.id Provider ID
 * @return {Promise|Error} A resolved Promise or Rejected with an Error
 */
export const deleteProvider = (data: { id: string }): Promise<any> => {
  const endpoint = format(GET_PROVIDER_ENDPOINT, data.id)

  return client.delete(endpoint)
}

export default deleteProvider
